import { useMemo } from 'react';

/**
 * Slot Check Search icon: a globe with a magnifying glass over its lower-right.
 * Gold (SlotCheck gold gradient #FBE7AD → #E5BA66 → #C99A3E) while a Slot
 * Check Search is saved for this session, otherwise white (#FFFFFF, same as
 * the casino header .search-icon).
 */
let idSeq = 0;

type Props = {
  active?: boolean;
  size?: number;
  className?: string;
  title?: string;
};

const SlotCheckSearchIcon = ({ active = false, size = 24, className, title }: Props) => {
  const ids = useMemo(() => {
    idSeq += 1;
    return { grad: `scs-gold-${idSeq}`, mask: `scs-mask-${idSeq}` };
  }, []);
  const stroke = active ? `url(#${ids.grad})` : '#FFFFFF';
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      data-active={active ? 'true' : 'false'}
    >
      {title ? <title>{title}</title> : null}
      <defs>
        <linearGradient id={ids.grad} x1="2" y1="2" x2="22" y2="22" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#FBE7AD" />
          <stop offset="0.5" stopColor="#E5BA66" />
          <stop offset="1" stopColor="#C99A3E" />
        </linearGradient>
        <mask id={ids.mask} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
          <rect x="0" y="0" width="24" height="24" fill="#fff" />
          <circle cx="16.6" cy="16.6" r="5.4" fill="#000" />
        </mask>
      </defs>
      <g mask={`url(#${ids.mask})`} stroke={stroke} strokeWidth="1.5" strokeLinecap="round">
        <circle cx="10" cy="10" r="7.6" />
        <ellipse cx="10" cy="10" rx="3.3" ry="7.6" />
        <path d="M2.6 10h14.8M3.8 6h12.4M3.8 14h12.4" />
      </g>
      <g stroke={stroke} strokeWidth="1.8" strokeLinecap="round">
        <circle cx="16.6" cy="16.6" r="3.5" />
        <path d="M19.2 19.2l2.9 2.9" />
      </g>
    </svg>
  );
};

export default SlotCheckSearchIcon;
